import { createPackageLogger, isDebugMode } from '@cloudbeds/frontend-logger';

export { isDebugMode };

/**
 * Simple custom log for given file name.
 * Only logs if __debug_mode is set in localStorage.
 * - Note: exception is log.error, which is always logged.
 *
 * Example usage:
 * ```
 * const logLocal = createLogLocal('PaymentElement.tsx');
 *
 * logLocal('onSubmit', 'Payment submitted');
 * // Output: [PT] [PaymentElement.tsx] onSubmit :: Payment submitted
 *
 * logLocal('onSubmit', 'payment:', payment);
 * // Output: [PT] [PaymentElement.tsx] onSubmit :: payment: { ... }
 *
 * logLocal.error('onSubmit', 'Error occurred');
 * // Output: [PT] [PaymentElement.tsx] onSubmit :: Error occurred
 * // Note: in this case, it's logged as an error message, and logs
 * // even if __debug_mode is not set.
 * ```
 */
export const createLogLocal = createPackageLogger('PT', {
  pkgNameStyles:
    'background: blue; color: white; padding: 2px 2px 2px 4px; margin-left: 1px; border-radius: 3px;',
});
